module.exports = __webpack_public_path__ + "static/media/home-activated.9031a74a.svg";